export default __webpack_public_path__ + "static/media/logo-fit-min.e07f1435.svg";